// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"843":"d7ee26a937cba9ff","3389":"72e1f5e19f1e0b90","3944":"b7990ef01ef26b45"}[chunkId] + ".js";
};